<template>
    <main-layout>

        <app-header icon="empty">
            Restitution
        </app-header>

        <action-bar :back="{name: 'home'}">
            <a class="btn add btn-full" id="main-action" :class="{disabled: saving}" @click.prevent="restitution">
                <i class="icon-go"></i>
                <strong>Rendre</strong>ces bouteilles
            </a>
        </action-bar>

        <filter-bar @searchBarChanged="updateSearch" placeholderFilter="Rechercher par Numéro, Otag">
        </filter-bar>

        <div v-if="this.bouteilles.length === 0" style="text-align: center">
            <br><br>
            <i class="icon-gas" style="font-size: 5rem; color: #ccc"></i>
            <h2 style="color: #ccc; margin-top: 0.5rem">Aucune bouteille à restituer</h2>
            <p style="color: #999; margin-top: 0.5rem">Vous n'avez aucune bouteille à restituer pour le moment</p>
            <br><br>
        </div>

        <div id="bouteilles-item" class="list list-bout bouteilles restitution">

            <div class="check" v-for="bout in filtredBottles()" :key="bout.id" :data-fournisseur="bout.fournisseur">
                <input type="checkbox" :id="'restit-'+bout.id" :name="'restit-'+bout.id" :value="bout.id" v-model="selected">
                <label :for="'restit-'+bout.id" class="item labcheck wrap" :class="classBouteille(bout.type)">
                    <p class="identification">
            <span>
              DISTRIBUTEUR
              <strong>{{ bout.fournisseur.nom }}</strong>
            </span>
                    <br> Bouteille
                        <strong v-if="bout.nom">{{ bout.nom.nom }}</strong>
                        <template v-if="bout.marque">
                            <br>
                            <span>
                                Marque
                                <strong class="marque">{{ bout.marque }}</strong>
                            </span>
                        </template>
                    </p>
                    <div class="floating">
                        <div class="id-bouteille">
                            <i class="icon-gas"></i>
                            {{ bout.code }}
                        </div>
                        <div class="refrigerant" v-if="bout.fluide">
                            <i class="icon-fluid"></i>
                            {{ bout.fluide.nom }}
                        </div>
                        <div class="otag" v-if="bout.otag">
                            <i class="icon-otag"></i>
                            {{ bout.otag }}
                        </div>
                    </div>
                    <i class="icon-valid check"></i>
                    <div class="clear"></div>
                    <span v-if="bout.otag" class="level-bar">
                        <span class="full-level"></span>
                        <span class="level" :style="getStyle(bout.poids_net, bout.poids_max)"></span>
                    </span>
                </label>
            </div>

        </div>

    </main-layout>
</template>

<script>
    import Bouteille from '../../js/models/Bouteille'
    import Scan from '../../js/models/Scan'

    export default {

        data() {
            return {
                bouteilles: [],
                selected: [],
                saving: false,
                strSearch: ''
            }
        },

        methods: {
            getStyle(poids_net, poids_max) {
                return {
                    width: Math.ceil(poids_net * 100 / poids_max) + '%'
                }
            },

            async fetchBouteilleClosed() {

                let listBouteilles = await Bouteille.getList();

                listBouteilles = listBouteilles.filter(function(bout) {
                    if(bout.actif === false) {
                        return true;
                    }
                })

                //filter listBouteille is cloture

                for(let bout in listBouteilles){
                    let res = await Bouteille.isRendable(listBouteilles[bout].id);

                    if(listBouteilles[bout].type !== "Fluide frigorigène" && listBouteilles[bout].poids_net !== 0){
                        res = false;
                    }

                    if(res === true) {
                        this.bouteilles.push(listBouteilles[bout])
                    }
                }

            },

            updateSearch(str) {
                this.strSearch = String(str[0]).toLowerCase()
            },

            classBouteille(type) {
                switch (type) {
                    case 'Fluide frigorigène':
                        return 'ff';
                    case 'Récupération':
                        return 'rec';
                    case 'Transfert':
                        return 'tf'
                }
            },

            async restitution() {
                if (this.saving) {
                    return;
                }

                let ids = this.selected.slice();

                if (ids.length > 0) {
                    this.saving = true;

                    Bouteille
                        .restitution(ids, false, true)
                        .then(() => {
                            this.$router.push({name: 'home'});
                            swal('Bouteille(s) restituée(s)', 'Restitution effectuée', 'success').then(() => {}, () => {});

                            // La géolocalisation peut prendre plusieurs secondes par bouteille (voire ne jamais
                            // répondre sur iOS) : la restitution est déjà enregistrée, on ne bloque plus l'écran.
                            this.enregistrerScans(ids);
                        }, () => {
                            this.saving = false;
                        })

                } else {
                    swal('Aucune bouteille sélectionnée', 'Veuillez au moins sélectionner une bouteille', 'warning')
                }
            },
            async enregistrerScans(ids) {
                let scanFailed = false;
                for (let id of ids) {
                    try {
                        await Scan.addOfflineScanBouteille(id)
                    } catch (err) {
                        scanFailed = true;
                    }
                }

                if (scanFailed) {
                    swal('Scan position', "La restitution est enregistrée mais le scan position n'a pas fonctionné, vérifiez les permissions de l'application", 'warning').then(() => {}, () => {})
                }
            },
            filtredBottles(searchTemp = null) {
                let search = this.strSearch;
                if(searchTemp !== null) {
                    search = searchTemp
                }

                return this.bouteilles.filter(b => {
                    let check = false;
                    if (_.has(b, 'fluide') && b.fluide && b.fluide.nom.toLowerCase().includes(search)) {
                        check = true
                    }

                    if(b.otag && b.otag.toLowerCase().includes(search)){
                        check = true
                    }

                    if(b.fournisseur.nom.toLowerCase().includes(search)){
                        check = true
                    }

                    if (b.code.toLowerCase().includes(search)) {
                        check = true
                    }
                    if (check) {
                        return b
                    }
                })
            }
        },

        computed: {

        },

        mounted() {
            this.fetchBouteilleClosed()
        }

    }

</script>


<style scoped>
    .list-bout.restitution input[type="checkbox"]:checked + .item > div:not(.clear) {
        border: none;
    }

    .point-1, .point-2, .point-3 {
        display: inline-block;
    }

    .point-1{
        animation: bounce 1s ease-in-out infinite;
    }

    .point-2{
        animation: bounce 1s ease-in-out 0.33s infinite;
    }

    .point-3{
        animation: bounce 1s ease-in-out 0.66s infinite;
    }
</style>



// WEBPACK FOOTER //
// RestitutionBouteilles.vue?561462b3